(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProfileTransferLimitController', ProfileTransferLimitController);

    ProfileTransferLimitController.$inject = ['$scope', '$window', '$rootScope', '$state', '$stateParams', '$http', '$translate', 'previousState', 'entity', 'CustomerTransferLimit'];

    function ProfileTransferLimitController($scope, $window, $rootScope, $state, $stateParams, $http, $translate, previousState, entity, CustomerTransferLimit) {
        var vm = this;

        vm.profile = entity;
        var monthKeys = [
            'jan', 'feb', 'mar', 'apr', 'may', 'jun',
            'jul', 'aug', 'sep', 'oct', 'nov', 'dec'
        ];

        function loadMonthNames() {
            var translateKeys = monthKeys.map(function (key) {
                return 'profile.detail.months.' + key;
            });

            $translate(translateKeys).then(function (translations) {
                vm.monthNames = monthKeys.map(function (key) {
                    return translations['profile.detail.months.' + key];
                });

                var now = new Date();
                var currentMonthName = vm.monthNames[now.getMonth()];

                vm.now = now;
                vm.startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
                vm.endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);

                vm.monthStart = vm.startOfMonth.getDate() + ' ' + currentMonthName;
                vm.monthEnd = vm.endOfMonth.getDate() + ' ' + currentMonthName;
            });
        }

        loadMonthNames();

        var translateWatcher = $rootScope.$on('$translateChangeSuccess', function () {
            loadMonthNames();
        });

        $scope.$on('$destroy', function () {
            translateWatcher();
        });

        loadAll();

        function loadAll() {
            CustomerTransferLimit.get({
                id: vm.profile.customerId,
            }, onSuccess, onError);

            function onSuccess(data) {
                vm.dailyTransferCount = data.dailyTransferCount;
                vm.monthlyTransferAmount = data.monthlyTransferAmount;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
    }
})();
